import { Modal as AntdModal, Typography } from "antd";
import type { ModalProps as AntdModalProps } from "antd";
import React from "react";

const { Title } = Typography;

export type ModalProps = Omit<AntdModalProps, "title"> & {
	title?: React.ReactNode;
	onClose?: () => void;
};

type CloseEvent = Parameters<NonNullable<ModalProps["onCancel"]>>[0];

const stopCloseEventPropagation = (event?: CloseEvent) => {
	event?.stopPropagation?.();
};

const Modal = ({
	title,
	children,
	onClose,
	onCancel,
	styles,
	footer,
	transitionName,
	width,
	...rest
}: ModalProps) => {
	const resolvedWidth = width ?? 400;
	const mergedStyles: AntdModalProps["styles"] = (info) => {
		const customStyles = typeof styles === "function" ? styles(info) : styles;
		return {
			header: {
				padding: "16px 24px",
				margin: 0,
				borderBottom: "1px solid var(--v2-border-subtle)",
				...(customStyles?.header || {}),
			},
			container: {
				padding: "0",
				...(customStyles?.container || {}),
			},
			body: {
				padding: "24px",
				...(customStyles?.body || {}),
			},
			mask: customStyles?.mask,
			footer: customStyles?.footer,
		};
	};

	return (
		<AntdModal
			{...rest}
			width={resolvedWidth}
			transitionName={transitionName ?? ""}
			footer={footer ?? null}
			onCancel={(event: CloseEvent) => {
				stopCloseEventPropagation(event);
				onCancel?.(event);
				onClose?.();
			}}
			title={
				typeof title === "string" ? (
					<Title level={4} style={{ margin: 0 }}>
						{title}
					</Title>
				) : (
					title
				)
			}
			styles={mergedStyles}
		>
			{children}
		</AntdModal>
	);
};

export default Modal;
